import { render, staticRenderFns } from "./BlockCategoryList.vue?vue&type=template&id=d908ca9e&"
import script from "./BlockCategoryList.vue?vue&type=script&lang=js&"
export * from "./BlockCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./BlockCategoryList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports